// extracted by mini-css-extract-plugin
module.exports = {"titleStyle":"LanguageSelector_titleStyle__2MLrO","titleStyleOpen":"LanguageSelector_titleStyleOpen__2PfUY"};